// extracted by mini-css-extract-plugin
export default {"ScreenThreshold":"600","AsideThreshold":"950","Navigation":"Navigation_Navigation__YFxUy"};